import { Box } from '@mui/material'
import Header from 'components/Header'
import SideBar from 'components/SideBar'
import { Outlet } from 'react-router-dom'

const Main = () => {
  return (
    <>
      <Header />
      <SideBar />
      <Box
        sx={{
          height: 1,
          pt: 10,
          pl: 35,
          pr: 6,
        }}
      >
        <Outlet />
      </Box>
    </>
  )
}

export default Main
